<script setup>
import { ref } from 'vue'

const emit = defineEmits(['closeTutorial'])

const currentStep = ref(1)
const totalSteps = 6

const tutorialContent = {
  1: {
    heading: "Alistar:",
    subheading: "Hello fellow muso,",
    text: [
      "Answer trivia questions by selecting",
      "1 of 3 answer options before the",
      "20 second timer runs out."
    ]
  },
  2: {
    heading: "Alistar: ",
    subheading: "Show off your music smarts,",
    text: [
      "Each question is worth 10 coins. ",
      "Answer 7,  20 second questions for",
      "a chance to WIN prizes."
    ]
  },
  3: {
    heading: "Alistar: ",
    subheading: "Can you catch the tune? ",
    text: [
      "Turn your volume up & listen to the ",
      "tune. Your  ears are your greatest",
      "weapon here! "
    ]
  },
  4: {
    heading: "Alistar: ",
    subheading: "Time to double you coins!",
    text: [
      "The bonus round is a chance to  ",
      "double your coins. You have just ",
      "10 seconds to answer the question."
    ]
  },
  5: {
    heading: "Alistar: ",
    subheading: "Gotta risk it all to reap the rewards.",
    text: [
      "Be careful, a wrong answer will",
      "halve your coins."
    ]
  },
  6: {
    heading: "Alistar: ",
    subheading: "I think you're ready.",
    subheading2: "Let's groove to victory",
    text: [
      "Keep answering music trivia to earn ",
      "more coins & climb the leaderboard.",
    ]
  },
}

const nextStep = () => {
  if (currentStep.value < totalSteps) {
    currentStep.value++
  } else {
    emit('closeTutorial')
  }
}

const skipTutorial = () => {
  emit('closeTutorial')
}

const closeTutorial = () => {
  emit('closeTutorial')
}

</script>

<template>
  <div class="tutorialOverlay">
    <div class="blurredBackground"></div>

    <div class="tutorialContent">
      <div class="col-12 tutorialImg">
        <img src="@/assets/tutorial/tutorial-img.png" alt="tutorial" class="col-9"/>
      </div>

      <div class="d-flex flex-column justify-content-center border speechBubble col-8 border">
        <div class="pad">
          <div class="heading">{{ tutorialContent[currentStep].heading }}</div>
          <div class="subheading">{{ tutorialContent[currentStep].subheading }}</div>
          <div v-if="tutorialContent[currentStep].subheading2" class="subheading">{{ tutorialContent[currentStep].subheading2 }}</div>

          <div
              v-for="(line, index) in tutorialContent[currentStep].text"
              :key="index"
              class="normalText"
          >
            {{ line }}
          </div>
        </div>

        <div class="d-flex flex-row justify-content-center gap-2 p-1 col-12">
          <div class="skip p-1 col-5" @click="skipTutorial">SKIP TUTORIAL</div>
          <div class="next yellowButton text-center p-1 col-5" @click="nextStep">
            {{ currentStep === totalSteps ? 'FINISH' : 'NEXT' }}
          </div>
        </div>
        <div class="text-center">{{ currentStep }}/{{ totalSteps }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tutorialOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.blurredBackground {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000015B2;
  backdrop-filter: blur(7.65px);
  -webkit-backdrop-filter: blur(7.65px);
  z-index: 1;
}

.tutorialContent {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.tutorialImg {
  position: absolute;
  bottom: 0;
  left: 0;
}

.heading{
  font-weight: 700;
  font-size: 18px;
  color: #000F56;
}

.subheading{
  font-weight: 600;
  font-size: 14px;
  color: #000F56;
}

.normalText{
  font-weight: 400;
  font-size: 14px;
  color: #000F56;
}

.next{
  font-weight: 600;
  font-size: 15px;
  color:#000000;
  cursor: pointer;
}

.yellowButton{
  background-color: #FFCB05;
  border-radius: 28px;
}

.skip{
  font-weight: 600;
  font-size: 12px;
  text-decoration: underline;
  color: #2B3771;
  cursor: pointer;
}

.speechBubble{
  position: absolute;
  bottom: 2%;
  right: 4%;
  background-color: #FFFFFFD9;
  border-radius: 10px;
  border-color: #4A5488;
  border-style: solid;
}

.pad{
  padding-left: 5%;
  padding-top: 5%;
}
</style>